export function withHash(data, hash) {
  return { ...data, hash: `${hash}` };
}
